export default __webpack_public_path__ + "static/media/total.5c77a8fb.png";